import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { RegistrationFieldType } from "@/model/Enums";
import { ExtraRegistrationField } from "@/model/ExtraRegistrationField";
import { FieldDependency, IFieldDependency } from "./FieldDependency";

export interface IRegistrationAnswer {
    key: string;
    fieldType: RegistrationFieldType;
    label: string;
    isMandatory: boolean;
    showIf: IFieldDependency;
    pathwayIds: Array<string>;
    value: string;
}

export class RegistrationAnswer implements IRegistrationAnswer {

    constructor(data?: IRegistrationAnswer) {
        if (data) this.update(data);
    }

    update(data: IRegistrationAnswer): RegistrationAnswer {
        mapData(data, {
            root: () => this,
            showIf: (data: IFieldDependency) => this.showIf.update(data)
        });
        return this;
    }

    key: string = "";
    fieldType: RegistrationFieldType = RegistrationFieldType.None;
    label: string = "";
    isMandatory: boolean = false;
    showIf: FieldDependency = new FieldDependency();
    pathwayIds: Array<string> = [];
    value: string = "";

    get valueText(): string {
        switch(this.fieldType) {
            case RegistrationFieldType.SingleText: return this.value;
            case RegistrationFieldType.MultiLineText: return this.value;
            case RegistrationFieldType.YesNo: return this.value.toLowerCase() === "true" ? "Yes" : "No";
            case RegistrationFieldType.Date: return Utils.dateText(this.value);
        }
        return this.value;
    }

    get componentName(): string {
        return RegistrationFieldType[this.fieldType] + "Field";
    }

    canShowForPathway(pathwayID?: string): boolean {
        if(!pathwayID) return true;                           // no pathway - defaults to showing (???)
        if((this.pathwayIds?.length ?? 0) === 0) return true; // no pathwayIDs means always show
        return this.pathwayIds.indexOf(pathwayID) > -1;       // only show if pathwayID is in the list
    }

    static fromRegistrationField(field: ExtraRegistrationField, availablePathwayIDs: Array<string>): RegistrationAnswer {
        // doing this long-hand rather than using some kind of 'clever' cloning (field and answer objects share a lot of property names...)
        const item = new RegistrationAnswer();
        item.key = field.key;
        item.fieldType = field.fieldType;
        item.label = field.label;
        item.isMandatory = field.isMandatory;
        item.showIf.update(field.showIf);
        // retrict the pathway filter IDs to only those that are in the active briefing!
        item.pathwayIds = field.pathwayIds.filter(id => availablePathwayIDs.indexOf(id) > -1);
        item.value = "";
        return item;
    }
}
